import { Button } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ImageHomeClient0 from '../../../src/Assets/Trouver_Expert_Qualifies.png';
import { buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { DrawImageHomeExpert19, DrawImageHomeExpert20, DrawImageHomeExpert21, DrawImageHomeExpert22, DrawImageHomeExpert23, DrawImageHomeExpert24 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
//DrawImageHomeExpert16
import useWindowSize from '../../hooks/useWindowSize';
import ImgPointsForts1 from './../../Assets/homePage/ImgPointsForts1.png';
import ImgPointsForts2 from './../../Assets/homePage/ImgPointsForts2.png';
import ImgPointsForts3 from './../../Assets/homePage/ImgPointsForts3.png';
import ImgPointsForts4 from './../../Assets/homePage/ImgPointsForts4.png';
import ImgPointsForts5 from './../../Assets/homePage/ImgPointsForts5.png';
//import CarouselComponent from './CarouselComponent';

function GlobalHomeClient() {

    const navigate=useNavigate();
    const { i18n } = useTranslation();
    usePersistedLanguage();
    //var items = [
    //    {
    //        name: 'Talih Aida',
    //        title: 'Title 1',
    //        description: 'Nous sommes extrêmement satisfaits de notre expérience avec High Tech Hires. Leur plateforme nous a permis de trouver rapidement des freelances hautement qualifiés pour nos projets. Grâce à leur  processus de matching efficace, nous avons pu trouver les profils idéaux correspondant à nos besoins spécifiques.',
    //        icon:<DrawImageHomeExpert16 />,
    //    },
    //    {
    //        name: 'El ouahabi Reda',
    //        title: 'Title 2',
    //        description: 'La simplicité de leur système de gestion des BDC, des CRA et de la facturation nous a grandement facilité la vie. Nous avons constaté une réduction significative des erreurs grâce à l\'automatisation du processus.',
    //        icon:<DrawImageHomeExpert16 />
    //    },
    //    {
    //        name:'Lahcen',
    //        title:'Title 3',
    //        description:'Ce qui nous a vraiment impressionnés, c\'est leur attention portée à la qualité du service. L\'équipe de High Tech Hires a été proactive et réactive tout au long du processus, nous guidant et répondant à nos questions avec diligence. Ils ont veillé à ce que notre collaboration avec les freelances se déroule sans accroc et à ce que nos attentes soient pleinement satisfaites.',
    //        icon:<DrawImageHomeExpert16 />
    //    },
    //    {
    //        name:'Oussama',
    //        title:'Title 3',
    //        description:'Nous recommandons vivement High Tech Hires à toute entreprise à la recherche de talents informatiques de qualité et d\'un service client exceptionnel. Ils ont véritablement amélioré notre capacité à mener à bien nos projets avec succès',
    //        icon:<DrawImageHomeExpert16 />
    //    }
    //];

    const {device}=useWindowSize();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',background:'white',height:'fit-content',width:'100%'}}>
                <NavbarHome />
                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch',paddingTop:'50px'}}>
                    <div
                        className='frame105HomePage'
                        id='expert'
                        style={{width:'90%'}}
                    >
                        <div className='frame106HomePage'>
                            <div className='frame107HomePage'>
                                <div className='frame108HomePage'>
                                    <h3 className='frame101HomePage'>
                                        {i18n.t('Trouvez les experts les plus qualifiés pour vos projets critiques.')}
                                    </h3>
                                    {device!='desktop' &&
                                    <div className='frame112HomePage'>
                                        <img
                                            src={ImageHomeClient0}
                                            style={{borderRadius:'20px'}}
                                        />
                                    </div>
                                    }

                                    <h6 className='frame110HomePage'>
                                        {i18n.t('Connectez-vous aux meilleurs Freelances et gérez facilement vos collaborateurs externes sur une seule et même plateforme grâce à notre solution « Source to Pay »')}
                                    </h6>
                                </div>
                                <div className='frame111HomePage'>
                                    <div className="frame0HomePage">
                                        <Button
                                            variant="contained"
                                            style={{...buttonStylesBlue(false),...{height: '48px',width:device=='desktop'?'auto':'100%'}}}
                                            onClick={()=>{
                                                navigate('/register');
                                            }}

                                        > {i18n.t('S\'inscrire')}
                                        </Button></div>

                                </div>
                            </div>
                            {device=='desktop' &&
                            <div className='frame112HomePage'>
                                <img
                                    src={ImageHomeClient0}
                                    style={{borderRadius:'20px'}}
                                />
                            </div>
                            }

                        </div>
                    </div>

                    <div className="homeExpertf27 homeExpertf30">
                        <div className="homeExpertf28">
                            <h5 className='homeExpertf16 homeExpertf31B'>
                                {i18n.t('Nous vous offrons')}
                            </h5>
                            <h3
                                className='frame101HomePage'
                                style={{textAlign:'center'}}
                            >
                                {i18n.t('Bien plus qu\'une simple plateforme de Sourcing!')}
                            </h3>
                        </div>
                        <div className="homeExpertf32">
                            <div className="homeExpertf33">
                                <DrawImageHomeExpert19 width={'100%'}/>
                                <div className='homeExpertf34'>
                                    <h5 className='homeExpertf16 homeExpertf31B'>
                                        {i18n.t('Freelance Marketplace')}
                                    </h5>
                                    <p className="homeExpertf35">
                                        {i18n.t('Publiez gratuitement une offre ou explorez notre CVthèque pour trouver le profil idéal correspondant à vos besoins de prestation.')}                                    </p>
                                </div>
                            </div>

                            <div className="homeExpertf33">
                                <DrawImageHomeExpert20 width={'100%'}/>
                                <div
                                    className='homeExpertf34'
                                    style={{paddingTop:device=='desktop' ? '60px':'0px'}}
                                >
                                    <h5 className='homeExpertf16 homeExpertf31B'>
                                        {i18n.t('Vendor Management Solution')}
                                    </h5>
                                    <p className="homeExpertf35">
                                        {i18n.t('Nous vous aidons à gérer vos ressources tout au long de vos prestations, y compris, la contractualisation avec les Freelances, la gestion des CRA, la facturation, et le suivi des missions.')}</p>
                                </div>
                            </div>
                        </div>

                        <Button
                            onClick={()=>{
                                navigate('/pricing');
                            }}
                            style={{...buttonStylesBlue(false),...{width:device=='desktop'?'auto':'100%'}}}
                        >
                            {i18n.t('Découvrez nos formules')}
                        </Button>

                    </div>

                    <div
                        className='homeExpertf1'
                        style={{width:'84%'}}
                    >
                        <div className="homeExpertf28">

                            <h3 className='homeExpertf19'>
                                {i18n.t('Comment ça marche')}
                            </h3>
                            <h5 className='homeExpertf16'>
                                {i18n.t('Vous avez déjà un projet et vous recherchez des ressources?')}
                            </h5>
                        </div>

                        <div
                            className='homeExpertf10345343'
                            style={{alignSelf:'stretch'}}
                        >
                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert21 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('1. Recherchez un Expert')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Publier une offre ou explorer notre CVTHèque')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert22 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('2. Get Matched')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Trouvez le profil qui match à votre projet')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert23 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('3. Contractualisez')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Contractualisez avec les Experts retenus')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert24 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('4. Suivez vos projets')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Gardez l\'œil sur vos projets et suivez-les')}
                                    </p>
                                </div>
                            </div>

                        </div>
                        <Button
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                            onClick={()=>{navigate('/register');}}
                        >{i18n.t('Nous Rejoindre')}</Button>

                    </div>

                    <div
                        className='homeExpertf1'
                        style={{width:'85%'}}
                    >
                        <h3 className='homeExpertf19'>
                            {i18n.t('Nos points forts')}
                        </h3>
                        <div
                            className='frame83HomePage'
                            style={{width:'100%'}}
                        >
                            <div className='frame89HomePage frame8098HomePage'>
                                <div
                                    className='frame90HomePage'
                                    style={{width:'16%'}}
                                >
                                    <img
                                        src={ImgPointsForts1}
                                        style={{width:'100%',height:'100%'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'
                                    style={{width:'84%'}}
                                >
                                    <div className='frame92HomePage'>
                                        <h5 className='homeExpertf16 homeExpertf31B'>
                                            {i18n.t('CVThèque à haute précision')}
                                        </h5>
                                        <div className='frame94HomePage'>
                                            <h6
                                                className="frame110HomePage"
                                                style={{textAlign:'left'}}
                                            >
                                                {i18n.t('Notre CVthèque utilise l\'intelligence artificielle pour vous offrir des résultats hautement précis, vous faisant gagner du temps précieux dans votre recherche de profils qualifiés.')}
                                            </h6>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className='frame89HomePage frame8098HomePage'>
                                <div
                                    className='frame90HomePage'
                                    style={{width:'16%'}}
                                >
                                    <img
                                        src={ImgPointsForts2}
                                        style={{width:'100%',height:'100%'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'
                                    style={{width:'84%'}}
                                >
                                    <div className='frame92HomePage'>
                                        <h5 className='homeExpertf16 homeExpertf31B'>
                                            {i18n.t('Gestion des candidatures')}
                                        </h5>
                                        <div className='frame94HomePage'>
                                            <h6
                                                className="frame110HomePage"
                                                style={{textAlign:'left'}}
                                            >
                                                {i18n.t('HTH assure la gestion des candidatures sélectionnées, qu\'elles proviennent de notre CVthèque ou en réponse à des appels d\'offres publiées.')}                                    </h6>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className='frame89HomePage frame8098HomePage'>
                                <div
                                    className='frame90HomePage'
                                    style={{width:'16%'}}
                                >
                                    <img
                                        src={ImgPointsForts3}
                                        style={{width:'100%',height:'100%'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'
                                    style={{width:'84%'}}
                                >
                                    <div className='frame92HomePage'>
                                        <h5 className='homeExpertf16 homeExpertf31B'>
                                            {i18n.t('Gestion des RDV')}
                                        </h5>
                                        <div className='frame94HomePage'>
                                            <h6
                                                className="frame110HomePage"
                                                style={{textAlign:'left'}}
                                            >
                                                {i18n.t('HTH propose un agenda intégré vous permettant de planifier et de gérer tous vos rendez-vous d\'entretiens avec les candidats sélectionnés.')}
                                            </h6>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className='frame89HomePage frame8098HomePage'>
                                <div
                                    className='frame90HomePage'
                                    style={{width:'16%'}}
                                >
                                    <img
                                        src={ImgPointsForts4}
                                        style={{width:'100%',height:'100%'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'
                                    style={{width:'84%'}}
                                >
                                    <div className='frame92HomePage'>
                                        <h5 className='homeExpertf16 homeExpertf31B'>
                                            {i18n.t('Gestion des CRA')}
                                        </h5>
                                        <div className='frame94HomePage'>
                                            <h6
                                                className="frame110HomePage"
                                                style={{textAlign:'left'}}
                                            >
                                                {i18n.t('Nous vous proposons une solution simple et pratique pour gérer les Comptes Rendus d\'Activité (CRA) de vos collaborateurs externes. Cette solution facilite la génération automatique de vos factures, ce qui contribue à limiter les erreurs.')}                                           </h6>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className='frame89HomePage frame8098HomePage'>
                                <div
                                    className='frame90HomePage'
                                    style={{width:'16%'}}
                                >
                                    <img
                                        src={ImgPointsForts5}
                                        style={{width:'100%',height:'100%'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'
                                    style={{width:'84%'}}
                                >
                                    <div className='frame92HomePage'>
                                        <h5 className='homeExpertf16 homeExpertf31B'>
                                            {i18n.t('Suivi des projets')}
                                        </h5>
                                        <div className='frame94HomePage'>
                                            <h6
                                                className="frame110HomePage"
                                                style={{textAlign:'left'}}
                                            >
                                                {i18n.t('Basé sur la méthode Kanban, HTH propose un outil de suivi intégré qui vous permet de suivre l\'avancement de vos projets de manière efficace et transparente.')}                                             </h6>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <Button
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                            onClick={()=>{navigate('/whyHtH');}}
                        >{i18n.t('En savoir plus')}</Button>
                    </div>

                    {/*masquer pour la v1*/}
                    {/*<CarouselComponent items={items} />*/}
                </div>
                <Footer />
            </div>
        </>
    );
}

export default GlobalHomeClient;